export enum CreateBankAccountStep {
    initialForm,
    failure,
    success,
    documentUpload
}
